<!--  -->
<template>
  <div class="footer-box">
    <div class="main-box">
      <div class="nav-wrapper" v-if="isSimple">
        <div class="wrapper-title">快速导航</div>
        <div class="wrapper-content click-nav">
          <!-- <div @click="toArrow('#news-box')">默尼大事件</div> -->
          <div @click="toArrow('#product-box')">产品介绍</div>
          <div @click="toArrow('#about-us')">关于我们</div>
          <!-- <div @click="toArrow('#join-us')">加入我们</div> -->
          <!-- <div @click="toArrow('go-merchant-entry')">商户入驻</div> -->
        </div>
      </div>
      <div class="contact-wrapper">
        <!-- <div class="wrapper-title">联系方式</div> -->
        <div class="wrapper-content">
          <div>联系电话： 020-87001473</div>
          <!-- <div>手机号码： 1380013800</div> -->
          <div>邮箱地址： kefu@gzmoninet.com</div>
          <div>联系地址： 广州市越秀区中山二路3号粤运大厦15楼B单元</div>
        </div>
      </div>
      <div class="qrcode-wrapper" v-if="isSimple">
        <div class="wrapper-title">我们的二维码</div>
        <div class="qrcode-content-wrapper">
          <img src="../../assets/images/drmocode.png" alt="" />
          <img src="../../assets/images/code_yunejia.png" alt="" />
        </div>
      </div>
    </div>
    <div class="website-footer">
      <div>
        Copyright 2025 广州默尼信息技术有限公司<span style="margin-left:10px"
          >版权所有</span
        >
      </div>
      <div class="web-msg" >
        <span
          @click="toOutWeb('https://beian.miit.gov.cn/#/Integrated/index')"
          style="margin-right:15px; display:inline-block;  text-align:right;"
          >粤ICP备2025418003号</span
        >
        <!-- <span
          style="margin-right:15px; display:inline-block;text-align:left;"
          @click="toCertPage"
          >增值电信业务经营许可证 粤B2-20180642</span
        > -->
        <span
          style="margin-right:15px; display:inline-block; "
          @click="toLicensePage(1)"
          >营业执照：91440113MAEAP4F043
        </span>
        <span
          style="margin-right:15px; display:inline-block; "
          @click="toLicensePage(2)"
          >互联网药品信息服务备案凭证：粤网药信备字(2025)第00579号
        </span>
        <!-- <span
          style="margin-right:15px;display:inline-block;"
          @click="toLicensePage(3)"
          >医疗器械网络交易服务第三方备案凭证：（粤）网械平台备字(2018)第00011号</span
        > -->
        <span
          style="margin-right:15px;display:inline-block;"
          @click="toLicensePage(5)"
          >医疗器械网络销售备案公示</span
        >
        <span
          style="margin-right:15px;display:inline-block;"
          @click="toLicensePage(6)"
          >第二类医疗器械经营备案凭证：粤穗药监械经营备20251832号</span
        >
        <!-- <span
          style="margin-right:15px;display:inline-block;"
          @click="toLicensePage(4)"
          >广州默尼医疗技术有限公司 资质文件</span
        > -->
       <!-- <span
          style="margin-right:15px;display:inline-block;"
          @click="toLicensePage(8)"
          >医疗器械网络交易服务第三方平台备案凭证：(粤)网械平台备字(2025)第00031号</span
        > -->
           <span
          style="margin-right:15px;display:inline-block;"
          @click="toLicensePage(7)"
          >仅销售预包装食品备案：YB14401040063920</span
        >
      </div>
      <div class="bottom-box" >
        <!-- <div class="qrcode-icon">
          <img src="../../assets/images/gov-icon.png" alt="" />
        </div>
        <div style=" padding:10px 0; ">
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color: #ff789e;">粤公网安备 （备案号在申请中，待定）</p></a>
        </div> -->
          <div
          @click="toOutWeb('https://beian.miit.gov.cn/')"
          style="margin-right:15px; display:inline-block;  text-align:right; cursor: pointer;"
          >粤ICP备 2025418003号-1</div
        >
      </div>
    </div>
  </div>
</template>

<script>
import "jquery";
export default {
  name: "",
  data() {
    return {
      isSimple: false
    };
  },

  props: [],

  watch: {},

  components: {},

  computed: {},

  created() {},

  methods: {
    toArrow(id) {
      if(id == "go-merchant-entry") {
        if( this.$route.name == "merchantEntry" ) return false;
        this.$router.push({name: "merchantEntry"});
        $("html,body").animate({ scrollTop: 0 }, 500);
        return false;
      }
      if (this.$route.name != "Index") {
        this.$router.push({
          name: "Index"
        });
        setTimeout(() => {
          var blog = $(id).offset().top;
          $("html,body").animate(
            {
              scrollTop: blog
            },
            500
          );
        }, 500);
      } else {
        var blog = $(id).offset().top;
        $("html,body").animate(
          {
            scrollTop: blog
          },
          500
        );
      }
    },
    toOutWeb(url) {
      window.open(url, "_blank");
      //window.location.href = url;
    },
    toCertPage() {
      //this.$router.push({name: 'Certificate'});
      let routeUrl = this.$router.resolve({
        path: "/certificate",
        query: {}
      });
      window.open(routeUrl.href, "_blank");
    },
    toLicensePage(e) {
      //this.$router.push({name: 'License'});
      let routeUrl = this.$router.resolve({
        path: "/license",
        query: {
          pageType: e
        }
      });
      window.open(routeUrl.href, "_blank");
    }
  }
};
</script>
<style lang="scss" scoped>
.bottom-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
}
.footer-box {
  width: 100%;
  padding: 40px 350px 20px 350px;
  box-sizing: border-box;
  background: #ffdfea;
  color: #ff789e;
  font-size: 20px;

  .main-box {
    display: flex;
    justify-content: center;  //simple

    .nav-wrapper {
      width: 281px;
      display: inline-block;
      vertical-align: top;
      text-align: left;
    }

    .contact-wrapper {
      // width: 566px;
      display: inline-block;
      vertical-align: top;
      text-align: left;
    }

    .qrcode-wrapper {
      width: 350px;
      display: inline-block;
      vertical-align: top;
      text-align: left;
    }

    .wrapper-content {
      margin-top: 5px;
      margin-bottom: 10px;
      text-align: left;
      font-size: 16px;
      line-height: 22px;
      height: 22px;
      display: flex;

      div {
        margin-bottom: 20px;
        margin-right: 25px;
      }
    }

    .click-nav {
      div {
        cursor: pointer;
      }

      div:hover {
        font-weight: bolder;
      }
    }

    .wrapper-title {
      font-size: 18px;
      line-height: 25px;
      font-weight: bold;
      text-align: left;
      display: inline-block;
    }

    .qrcode-content-wrapper {
      margin-top: 38px;
      width: 100%;
      display: flex;

      img:nth-child(odd) {
        width: 160px;
        height: 160px;
        margin-right: 30px;
        float: left;
      }

      img:nth-child(even) {
        width: 160px;
        height: 160px;
        float: left;
      }
    }
  }

  .website-footer {
    margin-top: 10px;
    font-size: 14px;
    color: #ff789e;
    line-height: 20px;

    div {
      margin-bottom: 5px;
    }

    .web-msg {
      span {
        display: inline-block;
        height: 25px;
        // width: 400px;
        a {
          color: #ff789e;
          text-decoration: none;
        }
      }

      span:hover {
        font-weight: bold;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/moniFooter/moniFooter.vue